import { render } from "./SlideMaker.vue?vue&type=template&id=0625f4f0"
import script from "./SlideMaker.vue?vue&type=script&lang=js"
export * from "./SlideMaker.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__